<template>
    <div :class="classNames">
        <div style="margin-bottom: 10px;">
            <el-button type="primary" @click="addCommentFun(0)">新增{{routeMeatTitle}}</el-button>
            <a style="color:#1989fa;margin-left: 12px;cursor:pointer;font-size:14px;text-decoration: none" target="_blank" href="https://doutuimao.feishu.cn/docs/doccnFTapIwin30nzOhgWWTxoge#uCavYn" >什么是{{routeMeatTitle}}?</a>
        </div>
        <div :class="commonName+ '_search'">
            <div :class="commonName + '_search_con'">
                <div :class="commonName + '_search_con_item'">
                    <span :class="commonName + '_search_con_item_title'">昵称</span>
                    <el-input placeholder="请输入昵称" v-model="searchObj.talent_name" style="width: 160px"></el-input>
                </div>
                <div :class="commonName + '_search_con_item'">
                    <span :class="commonName + '_search_con_item_title'">手机号</span>
                    <el-input placeholder="请输入手机号" v-model="searchObj.talent_phone" style="width: 140px"></el-input>
                </div>
                <div :class="[commonName + '_search_con_item', commonName + '_oprtation']">
                    <el-button type="primary" @click="searchRes">查询</el-button>
                </div>
                <div :class="[commonName + '_search_con_item', commonName + '_oprtation']">
                    <el-button type="primary" @click="exportExcel">导出</el-button>
                </div>
            </div>
        </div>
      <div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="appointlist.data" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}" @sort-change="onSortChange" :default-sort="{prop:'total_order',order:'descending'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
                    <el-table-column
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column v-for="(item, index) in headerList" :key="index" v-bind="item">
						<template slot-scope="scope">
                            <div v-if="item.prop === 'nick_avatar'" :class="classNames+ '_user'">
                                <img :src="scope.row.avatar_url" alt="">
                                <span>{{scope.row.name}}</span>
                            </div>
                            <template v-else-if="item.prop === 'product_list'">
                                <div v-if="scope.row.product_list && scope.row.product_list.length">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <p v-for="(item, index) in scope.row.product_list.slice(0,3)" :key="index">
                                                {{item}}
                                            </p>
                                            <p v-if="scope.row.product_list.length>3">......</p>
                                        </div>
                                        <div>
                                            <p class="product-name" v-for="(item, index) in scope.row.product_list.slice(0,3)" :key="index">
                                                {{item}}
                                            </p>
                                            <p v-if="scope.row.product_list.length>3">......</p>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </template>
                            <span v-else>{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100" fixed="right">
						<template slot-scope="scope">
                            <div class="operates-box">
                                <span :class="commonName+'_operation_title'" @click="addCommentFun(scope.row.id, scope.row)">编辑</span>
                                <span :class="commonName+'_operation_title'" @click="seeCharts(scope.row)">
                                    折线图
                                </span>
                                <span :class="commonName+'_operation_title'" @click="handleOpea(scope.row.id, scope.row)">{{scope.row.status === 1 ? '禁用': '启用'}}</span>
                            </div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changePageNum" @sizeChange="sizeChange" :total="appointlist.count" ref="pagination" v-model="searchObj.page" v-if="showPagination" :pageSizes="[10, 30, 50, 100]" layout="sizes,total,prev,pager,next"></Pagination>
		</div>
        <!-- <el-dialog
            :title="(id === 0 ? '新增' : '修改') + '定向推广员'"
            :visible.sync="dialogVisible"
            width="500px"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="handleClose"
            custom-class="submit_cofirm_dialog"
            >
            <span slot="footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit" :disabled="disabled">确 定</el-button>
            </span>
        </el-dialog> -->
        <chartsPop v-model="chartsPopObj.showPop" :ataid="chartsPopObj.ataid"></chartsPop>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import chartsPop from './components/chartsPop.vue'
import { commentData } from './data.js'
export default {
    name: 'SharePromotion',
    mixins: [commentData],
    components:{
        chartsPop
    },
    data() {
        const testScore = (value, callback, title) => {
            if(!value) {
                callback(new Error(title))
            }
            callback()
        }
        return {
            classNames: 'sharePromotion',
            noDataName: 'empty',
            dialogVisible: false,
            appointlist: {
                data: [],
                count: 0
            },
            searchObj: {
                limit: 10,
                page: 1,
                sort_field: 'total_order',
                sort_type: 'desc', // desc asc
                talent_name: '', // 昵称
                talent_phone: '' // 手机号
            },
            // isBindFlag: false,
            id: 0,
            disabled: false,
            chartsPopObj: { // 折线图弹窗相关
                showPop: false,
                ataid: ''
            }
        }
    },
    created() {
        this.getAppointlist(true)
    },
    computed: {
        ...mapState(['breadCrumbList']),
        routeMeatTitle() {
            return this.$route.meta.title
        },
        // 显示页码
        showPagination(){
            if(this.appointlist.count > 0){
                return true
            }else{
                return false
            }
        }
    },
    methods: {
        ...mapActions('help', ['appointlistFun', 'searchtalent', 'addappoint', 'editappoint']),
        ...mapActions('export', ['createExportAPI']),
        // 点击 折线图
        seeCharts(item){
            console.log('seeCharts-item:',item)
            this.chartsPopObj.ataid = item.id
            this.chartsPopObj.showPop = true
        },
        // 点击 查询
        searchRes(){
            this.getAppointlist(true)
        },
        // 监听排序
        onSortChange(e){
            if(e.order=="descending"){
                this.searchObj.sort_type = 'desc'
            }else{
                this.searchObj.sort_type = 'asc'
            }
            this.getAppointlist(true)
        },
        exportExcel() {
            this.$confirm('5分钟内仅可导出一次,导出后可在导出记录中查看导出进度,导出成功的数据请在24小时内下载', '导出提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '导出',
                cancelButtonText: '取消',
                customClass: ''
            })
            .then(async () => {
                await this.createExportAPI({
                    type: 8, // 1用户订单 2退款订单 3申诉订单 4发货订单 5线索订单 8定向推广
                    search_params: {
                        ...this.searchObj,
                        excel: 1
                    }
                })
                this.$router.push({
                    path:  this.staticPath + "exportHistory"
                })
            })
        },
        async handleOpea(id, row) {
            this.$confirm(`确定要${row.status === 1? '禁用': '启用'}吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(async () => {
                    await this.editappoint({id, type: 'status', status: row.status === 1? 2 : 1})
                    this.$set(row, 'status', row.status === 1? 2 : 1)
                    // this.getAppointlist()
                    this.$message({
                        type: 'success',
                        message: (row.status === 1? '启用' :'禁用') + '成功',
                        duration: 3000
                    })
                })
            
        },
        handleClose() {
            if(this.id === 0) {
                this.commentForm = {
                    talent_id: '',
                    rate: ''
                }
            }
            this.$nextTick(() => {
                this.$refs.ruleForm.clearValidate()
            })
        },
        addCommentFun(id, row) {
            if(id) {
                this.$router.push(this.staticPath + 'opearateSharePromotion/'+ id)
            } else {
                this.$router.push(this.staticPath + 'opearateSharePromotion')
            }
        },
        // 获取table列表
        async getAppointlist(isFirst) {
            if(isFirst){
                this.searchObj.page = 1
            }
            let res = await this.appointlistFun(this.searchObj)
            this.appointlist = res
        },
        // 改变页码
        changePageNum(pageNum) {
            this.searchObj.page = pageNum
            this.getAppointlist()
        },
        // 改变每页数量
        sizeChange(e){
            this.searchObj.limit = e
            this.getAppointlist(true)
        }
    }
}
</script>
<style lang="less" scoped>
    @classNames: sharePromotion;
    .@{classNames}_select {
        .el-select-dropdown__item {
            height: auto;
            line-height: normal;
            .has-child {
                padding-top: 8px;
                padding-bottom: 8px;
                display: flex;
                align-items: center;
                .@{classNames}-name {
                    max-width: 100px;
                    overflow-x: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
    .@{classNames} {
        height: 100%;
        .el-table::before {
			background-color: transparent;
		}
        .@{classNames}_table_bot_status_tit {
            width: 66px;
            height: 24px;
            border-radius: 12px;
            margin-right: 10px;
            text-align: center;
            line-height: 24px;
            display: block;
        }
        .@{classNames}_user {
            display: flex;
            align-items: center;
            img {
                width: 50px;
                height: 50px;
                object-fit: cover;
            }
            span {
                margin-left: 12px;
            }
        }
        .operates-box{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }
    }
    .product-name{
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
